import { cn } from '@theprintbar/shared';
import { ComponentProps, useEffect, useState } from 'react';

const starTypePaths = [
	'M13.192 18.482L14.7242 29.6735C14.9122 31.0454 16.895 31.0454 17.0829 29.6735L18.6152 18.482L29.8067 16.9497C31.1786 16.7618 31.1786 14.779 29.8067 14.591L18.6152 13.0588L17.0833 1.86731C16.8953 0.495403 14.9125 0.495403 14.7246 1.86731L13.1923 13.0588L2.00085 14.591C0.628948 14.779 0.628948 16.7618 2.00085 16.9497L13.1923 18.4816L13.192 18.482Z',
	'M14.4717 25.0353L15.1067 29.6735C15.2946 31.0454 17.2774 31.0454 17.4654 29.6735L18.1003 25.0353C18.6306 21.1614 21.677 18.1149 25.551 17.5847L30.1891 16.9497C31.561 16.7618 31.561 14.779 30.1891 14.591L25.551 13.956C21.677 13.4258 18.6309 10.3794 18.1003 6.50544L17.4654 1.86731C17.2774 0.495403 15.2946 0.495403 15.1067 1.86731L14.4717 6.50544C13.9415 10.3794 10.895 13.4258 7.02107 13.956L2.38293 14.591C1.01103 14.779 1.01103 16.7618 2.38293 16.9497L7.02107 17.5847C10.895 18.1149 13.9415 21.1614 14.4717 25.0353Z',
	'M12.2036 19.6599L13.4399 28.6899C13.8367 31.5887 18.0271 31.5883 18.4239 28.6899L19.6599 19.6599L28.6898 18.424C31.5886 18.0272 31.5886 13.8371 28.6898 13.44L19.6599 12.2037L18.4239 3.17412C18.0271 0.275292 13.8371 0.275292 13.4399 3.17412L12.2036 12.2037L3.174 13.44C0.275158 13.8368 0.275512 18.0272 3.174 18.424L12.2036 19.6599Z',
	'M9.80027 22.1092L10.2763 25.5878C11.21 32.4074 21.0679 32.4074 22.0012 25.5878L22.4773 22.1092L25.9559 21.6332C32.7754 20.6995 32.7754 10.8417 25.9559 9.9083L22.4773 9.43224L22.0012 5.95399C21.0675 -0.865524 11.2097 -0.865524 10.2763 5.95399L9.80027 9.43224H9.79992L6.32167 9.90866C-0.497848 10.8424 -0.497848 20.7002 6.32167 21.6335L9.79992 22.1096L9.80027 22.1092Z',
	'M5.93959 9.90803C-0.879928 10.8417 -0.879928 20.6996 5.93959 21.6329C7.99603 21.9143 9.61288 23.5315 9.89427 25.5876V25.5883C10.828 32.4082 20.6865 32.4074 21.6195 25.5876C21.9005 23.5315 23.517 21.9147 25.5731 21.6329H25.5742C32.3933 20.6985 32.3926 10.8414 25.5735 9.90768C23.5177 9.62629 21.9009 8.00946 21.6195 5.95373V5.95302C20.6858 -0.8665 10.828 -0.8665 9.89427 5.95302C9.61288 8.0091 7.99604 9.62593 5.93995 9.90768H5.93959V9.90803Z',
	'M8.39944 23.745C9.6694 33.0213 23.0784 33.0213 24.348 23.745L24.3483 23.7447C33.6243 22.4747 33.6246 9.06608 24.3483 7.79611H24.348C23.078 -1.48016 9.6694 -1.48016 8.39944 7.79576C8.39944 7.79576 8.39943 7.79611 8.39908 7.79647C-0.87684 9.06643 -0.87684 22.4754 8.39908 23.745H8.39944Z',
];

type Weight = 1 | 2 | 3 | 4 | 5 | 6;
interface BrandStarProps extends ComponentProps<'svg'> {
	weight?: Weight;
	image?: {
		url: string;
		key: string;
	};
	rotationAngle?: number;
}

export function BrandStarIcon({ className = 'w-4 h-4', ...props }: ComponentProps<'svg'>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" fill="none" className={cn(className)} {...props}>
			<path
				d="M7.15611 12.9041L7.46803 15.1824C7.56035 15.8563 8.53436 15.8563 8.62668 15.1824L8.9386 12.9041C9.19906 11.0011 10.6955 9.5046 12.5985 9.24414L14.8769 8.93222C15.5508 8.8399 15.5508 7.86589 14.8769 7.77357L12.5985 7.46165C10.6955 7.2012 9.19923 5.70472 8.9386 3.80174L8.62668 1.52338C8.53436 0.849467 7.56035 0.849467 7.46803 1.52338L7.15611 3.80174C6.89566 5.70472 5.39918 7.2012 3.4962 7.46165L1.21784 7.77357C0.543925 7.86589 0.543925 8.8399 1.21784 8.93222L3.4962 9.24414C5.39918 9.5046 6.89566 11.0011 7.15611 12.9041Z"
				strokeMiterlimit="10"
			/>
		</svg>
	);
}

export function BrandStar({ weight = 1, image, rotationAngle = 0, ...props }: BrandStarProps) {
	const patternId = `pattern-image-${image?.key}-${rotationAngle}`;
	const starPath = starTypePaths[weight - 1]; // Path for the star shape

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
			{image ? (
				<>
					<defs>
						{/* Define the pattern with the image */}
						<pattern
							id={patternId}
							patternUnits="objectBoundingBox"
							width="1"
							height="1"
							className="origin-center"
							style={{
								transform: `rotate(-${rotationAngle}deg)`,
							}}
						>
							<image
								href={image.url}
								x="0"
								y="0"
								width="32"
								height="32"
								preserveAspectRatio="xMidYMid slice"
								className="object-cover object-center"
							/>
						</pattern>
					</defs>

					<path
						fill={`url(#${patternId})`}
						d={starPath}
						style={{
							transform: `rotate(${rotationAngle}deg)`,
							transformOrigin: 'center',
							strokeLinecap: 'round',
							strokeLinejoin: 'round',
							strokeWidth: '0.1',
						}}
					/>
				</>
			) : (
				<path
					d={starTypePaths[weight - 1]}
					style={{
						strokeLinecap: 'round',
						strokeLinejoin: 'round',
					}}
				/>
			)}
		</svg>
	);
}

export function BrandStarAnimated(props: React.ComponentProps<'svg'>) {
	const [weight, setWeight] = useState<Weight>(1);

	useEffect(() => {
		const int = setInterval(() => {
			setWeight((val: Weight) => {
				if (val === 6) return 1;
				return (val + 1) as Weight;
			});
		}, 500);

		return () => clearInterval(int);
	}, []);

	return <BrandStar {...props} weight={weight} />;
}
